module.exports = __webpack_public_path__ + "static/media/logo_hypeschools_active.d41d8cd9.svg";